import { FunctionComponent, useEffect, useRef } from 'react';
import { sendMessage, useMessageListener } from 'utils/alphaOmega';

interface AoVersionTransformerIframeI {
  version: { title?: string; slug?: string; text?: string };
  submitCallback: (show: boolean) => void;
}

export const AoVersionTransformerIframe: FunctionComponent<AoVersionTransformerIframeI> =
  ({ version, submitCallback }: AoVersionTransformerIframeI) => {
    const aoHost = process.env.REACT_APP_AO_URL || '';
    const ref = useRef<HTMLIFrameElement>(null);

    useMessageListener('VersionTransformer', {
      mounted: () => sendMessage(ref, 'version', version),
      size: ({ height }) => {
        if (ref.current) {
          ref.current.style.height = `${height}px`;
        }
      },
      generating: () => {},
      submit: () => submitCallback(true)
    });

    useEffect(() => {
      sendMessage(ref, 'version', version);
      // This is a known false-positive.
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [version.text]);

    return (
      <iframe
        title="AO-VersionTransformer"
        ref={ref}
        src={`${aoHost}/embed/transform`}
        style={{ height: 400, width: '100%', border: 'none' }}
        onLoad={() => sendMessage(ref, 'version', version)}
      />
    );
  };
